import { render } from "./BaseWizard.vue?vue&type=template&id=d0f587e6"
import script from "./BaseWizard.vue?vue&type=script&lang=js"
export * from "./BaseWizard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__